import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FullScreenStateService {
  private _fullScreenState = signal<boolean>(false);
  public fullScreenState = this._fullScreenState.asReadonly();

  public toggleFullScreenState(): void {
    this._fullScreenState.set(!this.fullScreenState());
  }

  public resetFullScreenState(): void {
    this._fullScreenState.set(false);
  }
}
